var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',_vm._g(_vm._b({attrs:{"color":"redesignPrimaryDarken","rounded":"","block":""}},'app-button',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{staticClass:"mr-1"},[_vm._v("$i-telegram")]),_c('span',[_vm._v("Войти через Телеграм")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }